import React, { useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";

const GoBackBtn = (props) => {
    const { t } = useTranslation();
    const { goBack, viewsHistory } = useContext(BasicContext);
    const { classN } = props;

    return (
        <Container fluid="xl" className={classN ? classN : ""} id="goBackBtn">
            <Row>
                <Col>
                    {viewsHistory.length > 0 && (
                        <Button variant="outline-secondary" onClick={() => goBack()} className="my-3">
                            {t("goBack")}
                        </Button>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default GoBackBtn;
